import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Table,
  Dimmer,
  Loader,
  Icon,
  Segment,
  Item,
  Divider,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import LoanAmount from '../../components/LoanAmount';
import PageNav from '../../components/PageNav';
import CurrencySymbol from '../../components/CurrencySymbol';
import BOOKING_STATUSES from '../../constants/bookingStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

export const sortItems = [
  {
    text: 'Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'name',
    sortDirection: 'asc',
  },
  {
    text: 'Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'name',
    sortDirection: 'desc',
  },
  {
    text: 'Count Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'count',
    sortDirection: 'asc',
  },
  {
    text: 'Count Descending',
    icon: 'sort numeric descending',
    sortColumn: 'count',
    sortDirection: 'desc',
  },
  {
    text: 'Selling Price Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'spa_value',
    sortDirection: 'asc',
  },
  {
    text: 'Selling Price Descending',
    icon: 'sort numeric descending',
    sortColumn: 'spa_value',
    sortDirection: 'desc',
  },
];

class UsersBookings extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        currency: PropTypes.shape({
          code: PropTypes.string,
          symbol: PropTypes.string,
        }),
      }),
    }),
    headerColor: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
    onLoading: PropTypes.func,
    onPageNav: PropTypes.func,
    projectID: PropTypes.string,
    projectCurrencies: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    t: PropTypes.func,
  }
  static getQueryData = (props) => {
    const query = decodeSearch(props.location.search);
    const projectID = query.projectID || '';
    const sortColumn = query.sortColumn || '';
    const sortDirection = query.sortDirection || '';
    const page = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const dateRange = query.dateRange || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    return {
      projectID,
      sortColumn,
      sortDirection,
      page,
      search,
      dateRange,
      dateFrom,
      dateTo,
    };
  }
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const projectCurrencies = props.projectCurrencies;
    return {
      currentPage,
      projectCurrencies,
    };
  }
  constructor(props) {
    super(props);
    const state = UsersBookings.getPropsToState(props);
    this.state = {
      ...state,
      count: 0,
      data: [],
      limit: 0,
      loading: true,
      offset: 0,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.fetchReports(query);
  }
  componentWillReceiveProps(nextProps) {
    const query = UsersBookings.getQueryData(this.props);
    const newQuery = UsersBookings.getQueryData(nextProps);
    const refetch = (
      (query.projectID !== newQuery.projectID) ||
      (query.sortColumn !== newQuery.sortColumn) ||
      (query.sortDirection !== newQuery.sortDirection) ||
      (query.search !== newQuery.search) ||
      (query.dateRange !== newQuery.dateRange) ||
      (query.dateTo !== newQuery.dateTo) ||
      (query.dateFrom !== newQuery.dateFrom) ||
      (query.page !== newQuery.page)
    );
    const state = UsersBookings.getPropsToState(nextProps);
    this.setState({ ...state }, () => {
      if (refetch) {
        const q = decodeSearch(nextProps.location.search);
        this.fetchReports(q);
      }
    });
  }
  setComponentState(state = {}, cb) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
        if (cb) {
          cb();
        }
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
        if (this.props.onLoading) {
          this.props.onLoading(loading);
        }
      });
    });
  }
  getValueName = (value, arr) => {
    const { t } = this.props;
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: TRANSLATION_FILES.constants });
    }
    return '';
  }
  generatePivot = (data) => {
    const { t } = this.props;
    const pivot = [];
    data.forEach((d) => {
      const pivotData = {
        data: [],
        key: d.userID,
        rowSpan: 0,
        preferredName: d.preferredName,
        branchShortName: d.branchShortName,
      };
      const dataArr = [
        {
          title: this.getValueName('reserved', BOOKING_STATUSES),
          count: d.reservedCount,
          sumSPAValue: d.reservedSPAValue,
        },
        {
          title: this.getValueName('booked', BOOKING_STATUSES),
          count: d.bookedCount,
          sumSPAValue: d.bookedSPAValue,
        },
        {
          title: this.getValueName('sold_spa_signed', BOOKING_STATUSES),
          count: d.soldCount,
          sumSPAValue: d.soldSPAValue,
        },
        {
          title: this.getValueName('cancelled_developer', BOOKING_STATUSES),
          count: d.cancelledDeveloperCount,
          sumSPAValue: d.cancelledDeveloperSPAValue,
        },
        {
          title: this.getValueName('cancelled_availability', BOOKING_STATUSES),
          count: d.cancelledAvailabilityCount,
          sumSPAValue: d.cancelledAvailabilitySPAValue,
        },
        {
          title: this.getValueName('expired', BOOKING_STATUSES),
          count: d.expiredCount,
          sumSPAValue: d.expiredSPAValue,
        },
        {
          title: t('Total', { ns: TRANSLATION_FILES.constants }),
          count: d.totalCount,
          sumSPAValue: d.totalSpaValue,
        },
      ];
      // filtered out disabled row
      pivotData.data = dataArr.filter(v => !v.disabled);
      pivotData.rowSpan = pivotData.data.length;
      pivot.push(pivotData);
    });
    return pivot;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage }, () => {
      this.replaceQuery(query);
    });
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleCellSort = (key, defaultCell = false) => {
    const column = sortItems[key].sortColumn;
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    let direction = 'asc';
    if (defaultCell && (sortColumn === undefined)) {
      direction = 'desc';
    }
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.handleSortData(column, direction);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  cellCheckSorted(key, defaultCell = false) {
    const column = sortItems[key].sortColumn;
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    if (defaultCell && (sortColumn === undefined)) {
      return 'ascending';
    }
    if (column === sortColumn) {
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  async fetchReports(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    delete query.projectID;
    const projectID = (this.props.projectID || q.projectID) || '';
    if (projectID !== '') {
      query.projectID = projectID;
    }
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/reports/users/bookings/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-Count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const json = await res.json();
      const data = this.generatePivot(json);
      await this.setComponentState({
        count,
        data,
        limit,
        offset,
      }, this.handleOnPageNavData);
    }
    await this.setLoading(false);
  }
  handleOnPageNavData = () => {
    const { onPageNav } = this.props;
    if (onPageNav) {
      const { count, data, limit, offset } = this.state;
      const dataSize = data.length || 0;
      onPageNav({ count, dataSize, limit, offset });
    }
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  setPrefix() {
    const { projectCurrencies = [] } = this.state;
    const { appConfig = null } = this.props;
    if (projectCurrencies.length > 0) {
      return <CurrencySymbol />;
    }
    return (appConfig && appConfig.data && appConfig.data.currency) ? appConfig.data.currency.symbol : '';
  }
  render() {
    const { data, projectCurrencies } = this.state;
    const { t } = this.props;
    return (
      <Grid style={{ margin: '-1rem 0' }}>
        <Grid.Row>
          <Grid.Column>
            <Segment color={this.props.headerColor}>
              <Grid>
                <Grid.Row className="users-bookings table">
                  <Grid.Column className="mobile-report-table">
                    <Dimmer
                      inverted style={{ zIndex: 20 }}
                      active={this.state.loading}
                    >
                      <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                    </Dimmer>
                    {
                      data && data.length > 0 ?
                        <Table
                          celled
                          compact
                          unstackable
                          structured
                          sortable
                          style={{ marginTop: 0 }}
                        >
                          <Table.Header>
                            <Table.Row
                              style={{ borderBottom: '#bbb 2px solid' }}
                            >
                              <Table.HeaderCell
                                sorted={this.cellCheckSorted(0, true)}
                                onClick={() => this.handleCellSort(0, true)}
                              >
                                {t('Name')}
                                &nbsp;
                                {
                                  this.cellCheckSorted(0, true) ? null :
                                  <Icon
                                    inverted color="grey"
                                    name="sort"
                                  />
                                }
                              </Table.HeaderCell>
                              <Table.HeaderCell>{t('Booking Status')}</Table.HeaderCell>
                              <Table.HeaderCell
                                textAlign="right"
                                sorted={this.cellCheckSorted(2)}
                                onClick={() => this.handleCellSort(2)}
                              >
                                {
                                  this.cellCheckSorted(2) ? null :
                                  <Icon
                                    inverted color="grey"
                                    name="sort"
                                  />
                                }
                                &nbsp;
                                {t('Count')}
                              </Table.HeaderCell>
                              <Table.HeaderCell
                                textAlign="right"
                                sorted={this.cellCheckSorted(4)}
                                onClick={() => this.handleCellSort(4)}
                              >
                                {
                                  this.cellCheckSorted(4) ? null :
                                  <Icon
                                    inverted color="grey"
                                    name="sort"
                                  />
                                }
                                &nbsp;
                                {t('Selling Price Sum')}
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {
                              data.map(pivoted => (
                                pivoted.data.map((pivotedData, idxp) => (
                                  <Table.Row
                                    key={idxp}
                                    style={(pivoted.data.length === idxp + 1) ? { borderBottom: '#bbb 2px solid' } : {}}
                                  >
                                    {
                                    (pivoted.rowSpan && idxp === 0) &&
                                      <Table.Cell
                                        rowSpan={pivoted.rowSpan}
                                        style={{ borderBottom: '#bbb 2px solid' }}
                                      >
                                        {pivoted.preferredName}
                                        <br />
                                        <small>
                                          {pivoted.branchShortName}
                                        </small>
                                      </Table.Cell>
                                    }
                                    <Table.Cell style={pivotedData.title === 'Total' ? { fontWeight: 'bold' } : {}}>
                                      {pivotedData.title}
                                    </Table.Cell>
                                    <Table.Cell textAlign="right" style={pivotedData.title === 'Total' ? { fontWeight: 'bold' } : {}}>
                                      {pivotedData.count}
                                    </Table.Cell>
                                    <Table.Cell textAlign="right" style={pivotedData.title === 'Total' ? { fontWeight: 'bold' } : {}}>
                                      <LoanAmount
                                        projectCurrencies={projectCurrencies}
                                        format="0,000,000.00"
                                        amount={pivotedData.sumSPAValue}
                                        prefix={this.setPrefix()}
                                      />
                                    </Table.Cell>
                                  </Table.Row>
                                ))
                              ))
                            }
                          </Table.Body>
                        </Table>
                      : (
                        <Item>
                          <Item.Content>
                            <Segment textAlign="center">
                              {
                                this.state.loading ? <Divider hidden />
                                : `${t('No reports found')}.`
                              }
                            </Segment>
                          </Item.Content>
                        </Item>
                      )
                    }
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column textAlign="center">
                    <PageNav
                      upward
                      currentPage={this.state.currentPage}
                      count={this.state.count}
                      limit={this.state.limit}
                      offset={this.state.offset}
                      dataSize={this.state.data.length}
                      loading={this.state.loading}
                      onChange={this.handleChangePage}
                      noScrollTop
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(UsersBookings);



// WEBPACK FOOTER //
// ./src/components/Reports/UsersBookings.jsx